"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dateToEpochSeconds;
var _InvalidArgumentError = _interopRequireDefault(require("../errors/InvalidArgumentError"));
function dateToEpochSeconds(date) {
  if (!(date instanceof Date)) {
    throw new _InvalidArgumentError.default('date', 'must be instance of Date');
  }
  var millis = date.getTime();
  return Math.floor(millis / 1000);
}